/**
 * Frontend PII scrubber — removes or hashes sensitive data before sending to providers.
 * Domain-aware: strips birth data, chat content, astrologer names.
 */

const PII_KEYS = new Set([
  'email', 'phone', 'name', 'birth_date', 'birth_time', 'birth_place',
  'latitude', 'longitude', 'chat_content', 'message_body', 'message_text',
  'astrologer_name', 'user_name', 'cashfree_order_id', 'razorpay_payment_id',
  'pan_number', 'bank_account', 'ifsc_code', 'ip_address', 'user_agent',
]);

const HASHABLE_KEYS = new Set(['email', 'astrologer_id', 'user_id']);

async function hashValue(value) {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').substring(0, 16);
}

export async function scrubProperties(properties) {
  if (!properties) return properties;

  const scrubbed = { ...properties };
  for (const key of Object.keys(scrubbed)) {
    const lk = key.toLowerCase();
    if (PII_KEYS.has(lk)) {
      if (HASHABLE_KEYS.has(lk) && typeof scrubbed[key] === 'string') {
        scrubbed[key] = await hashValue(scrubbed[key]);
      } else {
        delete scrubbed[key];
      }
    }
  }
  return scrubbed;
}
